import React , {Component} from 'react';
import Link from 'gatsby-link';
import styles from './sales.module.scss';

class SignupPage extends Component
{
  constructor (props) {
    super(props);
    this.state = {
      name : '',
      email : '',
      company : '',
      job_title : '',
      phone : '',
      comments : '',
      nameValid : false,
      emailValid : false,
      companyValid : false,
      job_titleValid : false,
      phoneValid : false,
      commentsValid : false,
      formErrors: {name : '',email : '',company : '',job_title : '',phone : '',comments : ''},
      formValid: false,
      loading : false
    }
  }

  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({[name]: value},
                  () => { this.validateField(name, value) });
  }

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let nameValid = this.state.nameValid;
    let emailValid = this.state.emailValid;
    let companyValid = this.state.companyValid;
    let job_titleValid = this.state.job_titleValid;
    let phoneValid = this.state.phoneValid;
    let commentsValid = this.state.commentsValid;
    switch(fieldName) {
      case 'email':
        value = value.trim();
        if (value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) emailValid = true;
        fieldValidationErrors.email = emailValid ? '' : 'Please provide a valid email';
        break;
      case 'phone':
        value = value.trim();
        phoneValid = value.length >= 5;
        fieldValidationErrors.phone = phoneValid ? '': 'Phone number is too short';
        break;
      case 'name':
        value = value.trim();
        nameValid = value.length >= 1;
        fieldValidationErrors.name = nameValid ? '': 'Please provide your name';
        break;
      case 'company':
        value = value.trim();
        companyValid = value.length >= 1;
        fieldValidationErrors.company = companyValid ? '': 'Please provide your company name';
      break;
      default:
      break;
    }
    this.setState({formErrors: fieldValidationErrors,
                    nameValid: nameValid,
                    emailValid: emailValid,
                    companyValid : companyValid,
                    job_titleValid : job_titleValid,
                    phoneValid : phoneValid,
                    commentsValid : commentsValid
                  }, this.validateForm);
  }

  validateForm() {
    this.setState({formValid: (this.state.nameValid && this.state.phoneValid && this.state.companyValid && this.state.emailValid)});
  }

  handleSubmit = e => {
    e.preventDefault();
      this.setState({loading : true})
      const scriptUrl = 'https://script.google.com/macros/s/AKfycbwNTja2BfmVbYc_IM5cNQ2sXkkBagnISt9dAAGDe1Op94qYaT0/exec';
      const url = `${scriptUrl}?name=${this.state.name}&email=${this.state.email}&comments=${this.state.comments}&company=${this.state.company}&job_title=${this.state.job_title}&phone=${this.state.phone}`;
      var form_data = {
        name : this.state.name,
        email : this.state.email,
        company : this.state.company,
        job_title : this.state.job_title,
        phone : this.state.phone,
        comments : this.state.comments
      }
  
      fetch(url, {
        method: "GET",
        mode : "no-cors",
        dataType: "json"
      }).then((responseJson) => {
          this.setState({loading : false})
          alert("Thanks for contacting us. Our sales team shall get back to you shortly");
          this.setState({
            name : '',
            email : '',
            company : '',
            job_title : '',
            phone : '',
            comments : '',
            nameValid : false,
            emailValid : false,
            companyValid : false,
            job_titleValid : false,
            phoneValid : false,
            commentsValid : false,
            formErrors: {name : '',email : '',company : '',job_title : '',phone : '',comments : ''},
            formValid: false,
            loading : false
          });
        })
        .catch((error) => {
          this.setState({loading : false})
          console.error(error);
        });
  
  }

  render()
  {
    const { formErrors } = this.state
    return(
      <div className={styles.container}>
        <div className={styles.form__panel}>
        <form onSubmit={this.handleSubmit} data-netlify="true">
          <div className={styles.form__input__group}>
            <div className={styles.form__input__unit}>
              <label>
                Name<span className={styles.required__field}>*</span>
              </label>
              <input type="text" name="name" value={this.state.name} onChange={this.handleUserInput}/>
              {(formErrors.name != '') && <div className={styles.form_errors}>{formErrors.name}</div>}
            </div>
          </div>
          <div className={styles.form__input__group }>
            <div className={styles.form__input__unit}>
              <label>
                Email<span className={styles.required__field}>*</span>
              </label>
              <input type="text" name="email" value={this.state.email} onChange={this.handleUserInput} size="50"/>
              {(formErrors.email != '') && <div className={styles.form_errors}>{formErrors.email}</div>}
            </div>
          </div>
          <div className={styles.form__input__group}>
            <div className={styles.form__input__unit}>
              <label>
                Company<span className={styles.required__field}>*</span>
              </label>
              <input type="text" name="company" value={this.state.company} onChange={this.handleUserInput} size="50"/>
              {(formErrors.company != '') && <div className={styles.form_errors}>{formErrors.company}</div>}
            </div>
          </div>
          <div className={styles.form__input__group}>
            <div className={styles.form__input__unit}>
              <label>
                Job Title
              </label>
              <input type="text" name="job_title" value={this.state.job_title} onChange={this.handleUserInput} size="50"/>
              {(formErrors.job_title != '') && <div className={styles.form_errors}>{formErrors.job_title}</div>}
            </div>
          </div>
          <div className={styles.form__input__group}>
            <div className={styles.form__input__unit}>
              <label>
                Phone<span className={styles.required__field}>*</span>
              </label>
              <input type="tel" name="phone" value={this.state.phone} onChange={this.handleUserInput} size="50"/>
              {(formErrors.phone != '') && <div className={styles.form_errors}>{formErrors.phone}</div>}
            </div>
          </div>
          <div className={styles.form__input__group}>
            <div className={styles.form__input__unit}>
              <label>
                Comments
              </label>
              <textarea type="text" name="comments" value={this.state.comments} onChange={this.handleUserInput} size="50" rows="4"/>
              {(formErrors.comments != '') && <div className={styles.form_errors}>{formErrors.comments}</div>}
            </div>
          </div>
          <button type="submit" disabled={!this.state.formValid} className={(this.state.formValid?styles.landing__btn : styles.landing__btn_disabled)}><span>{(this.state.loading?"Submitting..." : "Submit")}</span></button>
        </form>
        </div>
      </div>
    )
  }
}

export default SignupPage;



// WEBPACK FOOTER //
// ./src/pages/sales.js